<template>
  <div>
    <div :class="{ marginTop: marginTop }">
      <label class="vs-select--label input-select-label-primary">{{
        titleText
      }}</label>
      <multiselect
        :openDirection="openDirection"
        :value="value"
        :label="label"
        :options="options"
        @input="updateSelection"
      ></multiselect>
      <span class=" ml-1 text-danger text-sm" v-show="showValidation">
        {{ validationText }}
      </span>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  name: "SelectWithLabel",
  components: {
    ValidationProvider
  },
  props: {
    openDirection: {
      type: String,
      default: ""
    },
    marginTop: {
      type: Boolean,
      default: true
    },
    showValidation: {
      type: Boolean,
      default: false
    },
    value: "",
    label: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    validationText: {
      type: String,
      default: "Validation requirements not met"
    },
    titleText: {
      type: String,
      default: `Select:`
    }
  },
  methods: {
    updateSelection(selection) {
      this.$emit("input", selection);
    }
  }
};
</script>

<style scoped>
.marginTop {
  margin-top: 7px;
}
</style>
